<template>
   <div class="not-found">
      <div class="error-message">
         <div class="error-details">
            <BrandIcon class="logo" />
            <div class="message">
               Oops! The page you are looking for doesn't exist.
            </div>
            <router-link to="/" class="btn btn-default primary-btn">Go Back To Home</router-link>
         </div>
      </div>
   </div>
</template>
<script>
import BrandIcon from '@/components/IconComponents/BrandIcon.vue';
export default {
    components:{
      BrandIcon
    }
}
</script>
<style scoped>
    .not-found{
      height:100vh;
      display: flex;
      justify-content: center;
      padding-top:5rem;
    }

   
    .error-details{
      display: grid;
      row-gap:0.8rem;
      grid-template-rows: auto auto auto;
    }

     .logo{
      color:var(--primary);
      justify-self: center;
      height: 5rem;
      width:5rem;
      margin-bottom: 1.5rem;
     
    }

    .message{
       font-family: var(--heading-font2-regular);
    }

    @media(max-width: 786px){
      .primary-btn{
         margin:0rem 3rem;
      }

      .message{
         margin:0rem 1.5rem;
         text-align: center;
      }
    }

</style>